<template>
  <div>
    <vs-button 
      color="white"
      style="border-radius: 5px; margin: 10px; padding: 0px"
      type=""
      size="sm"
      @click="masrafSil"
    >
      <b-icon icon="trash-fill" type="border" size="medium" variant="danger"></b-icon>
    </vs-button> 
  </div>
</template>

<script>
import Store from "../../../../store/store";
import state from "../../../../store/state";
import vSelect from "vue-select";
import moment from "moment";

export default {
  data() {
    return {
     
      
      plas: "",
      params: { data: { Id: 0 } }, // params değişkenini tanımla ve başlangıç değerini ata
    };
  },
  created() {
    this.plas = Store.state.plasiyer;
  },

  components: {
    "v-select": vSelect,
  },
  methods: {
    masrafSil() 
    {
      this.$root.$emit('masrafSil', this.params.data.Id);

    }

    
          
  },
  
  beforeMount() {
    //...
    
  },
};
</script>
